// AI Solutions Category
import { ShowcaseCategory } from "../showcase-types.ts";
import { ICONS } from "../showcase-icons.ts";

export const aiSolutionsCategory: ShowcaseCategory = {
  id: "ai-solutions",
  title: {
    en: "AI Solutions",
    lv: "MI Risinājumi",
    it: "Soluzioni AI",
  },
  subtitle: {
    en: "Intelligent automation powered by artificial intelligence",
    lv: "Inteliģenta automatizācija, ko darbina mākslīgais intelekts",
    it: "Automazione intelligente alimentata dall'intelligenza artificiale",
  },
  iconGradient: "from-indigo-500 to-purple-600",
  iconSvgPath: ICONS.lightbulb,
  projects: [
    {
      id: "ai-news-digest",
      title: {
        en: "AI-Powered News Digest Automation",
        lv: "MI Ziņu Kopsavilkuma Automatizācija",
        it: "Automazione Digest Notizie con IA",
      },
      industry: {
        en: "Business Consultancy",
        lv: "Biznesa Konsultācijas",
        it: "Consulenza Aziendale",
      },
      description: {
        en:
          "We developed an intelligent workflow that automatically monitors industry news sources, filters relevant content using AI, and delivers personalized daily digests to stakeholders. This solution eliminates hours of manual research while ensuring teams stay informed about critical market developments.",
        lv:
          "Mēs izstrādājām inteliģentu darba plūsmu, kas automātiski uzrauga nozares ziņu avotus, filtrē atbilstošu saturu, izmantojot MI, un piegādā personalizētus ikdienas kopsavilkumus ieinteresētajām personām. Šis risinājums novērš stundām ilgu manuālo izpēti, vienlaikus nodrošinot, ka komandas ir informētas par kritiskiem tirgus notikumiem.",
        it:
          "Abbiamo sviluppato un flusso di lavoro intelligente che monitora automaticamente le fonti di notizie del settore, filtra i contenuti rilevanti utilizzando l'IA e fornisce digest giornalieri personalizzati agli stakeholder. Questa soluzione elimina ore di ricerca manuale garantendo che i team rimangano informati sugli sviluppi critici del mercato.",
      },
      keyOutcomes: [
        {
          text: {
            en: "Automated daily news monitoring and curation",
            lv: "Automatizēta ikdienas ziņu uzraudzība un kurēšana",
            it: "Monitoraggio e cura automatizzata delle notizie quotidiane",
          },
        },
        {
          text: {
            en: "AI-powered content filtering and relevance scoring",
            lv: "MI satura filtrēšana un atbilstības vērtēšana",
            it:
              "Filtraggio dei contenuti e punteggio di rilevanza basati sull'IA",
          },
        },
        {
          text: {
            en: "Personalized delivery to stakeholder inboxes",
            lv: "Personalizēta piegāde ieinteresēto personu pastkastēs",
            it:
              "Consegna personalizzata alle caselle di posta degli stakeholder",
          },
        },
      ],
      techBadges: [
        { name: "n8n", colorClass: "bg-indigo-100 text-indigo-700" },
        { name: "OpenAI", colorClass: "bg-purple-100 text-purple-700" },
        { name: "RSS Feeds", colorClass: "bg-blue-100 text-blue-700" },
        { name: "Email Automation", colorClass: "bg-green-100 text-green-700" },
      ],
      metric: {
        value: "90%",
        label: {
          en: "Time Saved",
          lv: "Ietaupīts Laiks",
          it: "Tempo Risparmiato",
        },
        sublabel: {
          en: "on research tasks",
          lv: "izpētes uzdevumos",
          it: "su attività di ricerca",
        },
        colorClass: "text-indigo-600",
        bgGradient: "from-indigo-50 to-purple-50",
      },
      iconGradient: "from-indigo-500 to-purple-600",
      iconSvgPath: ICONS.lightbulb,
    },
    {
      id: "web-product-catalog-pim",
      title: {
        en: "Web Product Catalog + PIM Prototype in 48 Hours",
        lv: "Tīmekļa Produktu Katalogs + PIM Prototips 48 Stundās",
        it: "Catalogo Prodotti Web + Prototipo PIM in 48 Ore",
      },
      industry: {
        en: "Business Consultancy Company",
        lv: "Biznesa Konsultāciju Uzņēmums",
        it: "Società di Consulenza Aziendale",
      },
      description: {
        en:
          "As a proof-of-concept, we built a multi-web product catalog and PIM prototype in 48 hours, using a combination of AI tools and very little custom code (mostly via n8n). The solution demonstrated how AI can accelerate product information extraction and transform them into a PoC, lowering the barrier for the same purpose can bypass costly tools, lowering the barrier for the same purpose.",
        lv:
          "Kā koncepcijas pierādījums, mēs izveidojām daudzkanālu tīmekļa produktu katalogu un PIM prototipu 48 stundās, izmantojot AI rīku kombināciju un ļoti maz pielāgota koda (galvenokārt caur n8n). Risinājums demonstrēja, kā AI var paātrināt produktu informācijas izguvi un pārveidot tās PoC, samazinot barjeru tam pašam mērķim var apiet dārgus rīkus.",
        it:
          "Come prova di concetto, abbiamo costruito un catalogo prodotti web multi-canale e un prototipo PIM in 48 ore, utilizzando una combinazione di strumenti AI e pochissimo codice personalizzato (principalmente tramite n8n). La soluzione ha dimostrato come l'AI possa accelerare l'estrazione delle informazioni sui prodotti e trasformarle in un PoC, abbassando la barriera per lo stesso scopo può bypassare strumenti costosi.",
      },
      keyOutcomes: [
        {
          text: {
            en:
              "Custom Computer Vision OCR to extract product information from the images",
            lv:
              "Pielāgota Datora Redzes OCR, lai izvilktu produktu informāciju no attēliem",
            it:
              "OCR di Computer Vision personalizzato per estrarre informazioni sui prodotti dalle immagini",
          },
        },
        {
          text: {
            en:
              "Data model and uploaded to AirTable, then auto catalogued (thanks to its own AI tools)",
            lv:
              "Datu modelis un augšupielādēts AirTable, pēc tam automātiski katalogizēts (pateicoties tā pašu AI rīkiem)",
            it:
              "Modello dati e caricato su AirTable, quindi catalogato automaticamente (grazie ai suoi strumenti AI)",
          },
        },
        {
          text: {
            en:
              "Free AI to remove background from the images (and left web-ready product images)",
            lv:
              "Bezmaksas AI, lai noņemtu fonu no attēliem (un atstātu tīmeklim gatavus produktu attēlus)",
            it:
              "AI gratuita per rimuovere lo sfondo dalle immagini (e lasciare immagini di prodotti pronte per il web)",
          },
        },
        {
          text: {
            en:
              "AirTable extension framework (React) set up boilerplate as baseline for the layout",
            lv:
              "AirTable paplašinājuma ietvars (React) iestatīts kā pamats izkārtojumam",
            it:
              "Framework di estensione AirTable (React) configurato come base per il layout",
          },
        },
      ],
      techBadges: [
        {
          name: "Custom Python WebAPI",
          colorClass: "bg-blue-100 text-blue-700",
        },
        { name: "AI OCR", colorClass: "bg-purple-100 text-purple-700" },
        { name: "AirTable", colorClass: "bg-orange-100 text-orange-700" },
        { name: "React", colorClass: "bg-cyan-100 text-cyan-700" },
        { name: "AI Tools", colorClass: "bg-indigo-100 text-indigo-700" },
      ],
      metric: {
        value: "48h",
        label: { en: "Go-Live", lv: "Palaišana", it: "Go-Live" },
        sublabel: {
          en: "from development to production",
          lv: "no izstrādes līdz ražošanai",
          it: "dallo sviluppo alla produzione",
        },
        colorClass: "text-purple-600",
        bgGradient: "from-purple-50 to-pink-50",
      },
      iconGradient: "from-purple-500 to-pink-600",
      iconSvgPath: ICONS.lightbulb,
    },
    {
      id: "slack-ai-rag-chatbot",
      title: {
        en: "Slack AI RAG Chatbot",
        lv: "Slack AI RAG Čatbots",
        it: "Chatbot RAG AI per Slack",
      },
      industry: {
        en: "Business Consultancy Company",
        lv: "Biznesa Konsultāciju Uzņēmums",
        it: "Società di Consulenza Aziendale",
      },
      description: {
        en:
          "We designed and implemented the first prototype of an AI-powered RAG chatbot integrated with Slack, enabling team members to ask natural-language questions about company documents and source code directly within their daily chat environment. The project laid the foundation for an internal AI assistant later expanded and productized by the company.",
        lv:
          "Mēs izstrādājām un ieviesām pirmo AI darbināta RAG čatbota prototipu, kas integrēts ar Slack, ļaujot komandas locekļiem uzdot dabīgās valodas jautājumus par uzņēmuma dokumentiem un pirmkodu tieši viņu ikdienas čata vidē. Projekts lika pamatu iekšējam AI asistentam, ko vēlāk uzņēmums paplašināja un pārvērta produktā.",
        it:
          "Abbiamo progettato e implementato il primo prototipo di un chatbot RAG alimentato dall'AI integrato con Slack, permettendo ai membri del team di porre domande in linguaggio naturale sui documenti aziendali e il codice sorgente direttamente nel loro ambiente di chat quotidiano. Il progetto ha gettato le basi per un assistente AI interno successivamente espanso e prodottizzato dall'azienda.",
      },
      keyOutcomes: [
        {
          text: {
            en:
              "Proof of concept delivered. The prototype validated the technical feasibility and internal value of Slack-native AI assistants",
            lv:
              "Koncepcijas pierādījums piegādāts. Prototips apstiprināja tehnisko iespējamību un Slack-native AI asistentu iekšējo vērtību",
            it:
              "Proof of concept consegnato. Il prototipo ha validato la fattibilità tecnica e il valore interno degli assistenti AI nativi per Slack",
          },
        },
        {
          text: {
            en:
              "Adopted for expansion. After our delivery, the company's internal dev team took over to evolve the system toward production",
            lv:
              "Pieņemts paplašināšanai. Pēc mūsu piegādes uzņēmuma iekšējā izstrādes komanda pārņēma sistēmu, lai attīstītu to uz ražošanu",
            it:
              "Adottato per l'espansione. Dopo la nostra consegna, il team di sviluppo interno dell'azienda ha preso in carico l'evoluzione del sistema verso la produzione",
          },
        },
        {
          text: {
            en:
              "Improved knowledge accessibility. Employees could find answers to code and documentation questions without leaving Slack",
            lv:
              "Uzlabota zināšanu pieejamība. Darbinieki varēja atrast atbildes uz koda un dokumentācijas jautājumiem, neatstājot Slack",
            it:
              "Migliorata l'accessibilità delle conoscenze. I dipendenti potevano trovare risposte alle domande sul codice e sulla documentazione senza lasciare Slack",
          },
        },
      ],
      techBadges: [
        {
          name: "Custom Python Web API",
          colorClass: "bg-blue-100 text-blue-700",
        },
        {
          name: "Slack Application",
          colorClass: "bg-purple-100 text-purple-700",
        },
        {
          name: "MongoDB (Vector Database)",
          colorClass: "bg-green-100 text-green-700",
        },
      ],
      metric: {
        value: "PoC",
        label: { en: "Delivered", lv: "Piegādāts", it: "Consegnato" },
        sublabel: {
          en: "foundation for production system",
          lv: "pamats ražošanas sistēmai",
          it: "base per il sistema di produzione",
        },
        colorClass: "text-blue-600",
        bgGradient: "from-blue-50 to-indigo-50",
      },
      iconGradient: "from-blue-500 to-indigo-600",
      iconSvgPath: ICONS.lightbulb,
    },
  ],
};
